/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_Faq_A2Inputs */

const en_guide_large_json_files_faq_a2 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. A 100 MB formatted JSON file with 4-space indentation typically becomes 40-60 MB after minification. This saves significant time for transfers, storage, and API responses.`)
};

const ko_guide_large_json_files_faq_a2 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 4칸 들여쓰기로 포맷된 100 MB JSON 파일은 압축 후 일반적으로 40-60 MB가 됩니다. 전송, 저장, API 응답에서 상당한 시간을 절약할 수 있습니다.`)
};

const ja_guide_large_json_files_faq_a2 = /** @type {(inputs: Guide_Large_Json_Files_Faq_A2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。4スペースインデントの100MBのフォーマット済みJSONファイルは、圧縮後に通常40〜60MBになります。転送、ストレージ、APIレスポンスにおいて大幅な時間の節約になります。`)
};

/**
* | output |
* | --- |
* | "Yes. A 100 MB formatted JSON file with 4-space indentation typically becomes 40-60 MB after minification. This saves significant time for transfers, storage,..." |
*
* @param {Guide_Large_Json_Files_Faq_A2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_faq_a2 = /** @type {((inputs?: Guide_Large_Json_Files_Faq_A2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_Faq_A2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_faq_a2(inputs)
	if (locale === "ko") return ko_guide_large_json_files_faq_a2(inputs)
	return ja_guide_large_json_files_faq_a2(inputs)
});